<template>
  <div class="equipments-board">
    <div class="column">
      <h6>Brand</h6>
      <div
        v-for="(brand, index) in getBrandList(category)"
        :key="index"
        :class="['row', 'brand', { active: brand === selectedBrand }]"
        @click="selectEquipment(brand)"
      >
        {{ brand }}
      </div>
    </div>
    <div class="column">
      <h6>Machine Model</h6>
      <div v-for="(model, index) in selectedEquipment" :key="index" class="row">
        {{ model["Machine Model"] }}
      </div>
    </div>
    <div class="column">
      <h6>Machine Quantity</h6>
      <div
        v-for="(quantity, index) in selectedEquipment"
        :key="index"
        class="row"
      >
        {{ quantity["Machine Quantity"] }}
      </div>
    </div>
  </div>
</template>

<script>
import "./_EquipmentsBoard.scss";
export default {
  props: {
    category: String,
    equipmentList: Array,
  },
  data() {
    return {
      selectedEquipment: this.equipmentList.filter((x) => x.Brand === this.equipmentList[0].Brand),
      selectedBrand: this.equipmentList[0].Brand,
    };
  },
  methods: {
    getBrandList() {
      return Array.from(new Set(this.equipmentList.map((item) => item.Brand)));
    },
    selectEquipment(brand) {
      this.selectedBrand = brand;
      this.selectedEquipment = this.equipmentList.filter((y) => y.Brand === brand);
    },
  },
};
</script>
